var DialogView = require('dialogview');

var scriptjs = require('scriptjs');
var util = require('../../lib/util.es6');
var StripeCardDialogView = require('../stripe-card-dialog-view.es6').default;

var stripeDialog = new StripeCardDialogView();

var PayViewMixins = {
    // clickPayButton (fun clickEvent)
    // billingCancelSureText (str)
    // formatPlan (fun billingInfo)
    // formatSubscriptionInvoiceItem (fun subscription)
    initialize: function (options) {
        this.model.bind('billingUpdate', this.renderBillingDetails, this);
        this.model.bind('billingUpdate', this.renderPay, this);
        this.model.bind('billingInfoError', this.renderBillingInfoError, this);
        this.seenTokens = {};
    },
    events: {
        'buttonClick .payButton': 'clickPayButton',
        'click .payButton': 'clickPayButton'
    },
    loadStripeOld: function () {
        if (PayViewMixins._loadStripeCalled) {
            return;
        }
        PayViewMixins._loadStripeCalled = true;
        scriptjs([
            "https://js.stripe.com/v2/",
            "https://checkout.stripe.com/checkout.js"
        ], _.bind(function () {
            if (window.StripeCheckout) {
                PayViewMixins.StripeCheckout = window.StripeCheckout.configure(
                    window.IRCConfig.StripeCheckoutOptions
                );
                scriptjs.done('stripe');
            } else {
                this.renderStripeError();
            }
        }, this));
    },
    hidePayError: function () {
        this.$('.payError').hide();
    },
    getCountryEvidenceLabel: function (key) {
        switch (key) {
        case 'ip':
            return 'IP address';
        case 'billing':
            return 'Billing address';
        case 'origin':
            return 'Billing origin';
        case 'vat':
            return 'VAT country';
        case 'self_certified':
            return 'Confirmation';
        }
    },
    formatCountryEvidence: function (country_evidence) {
        var seen = {};
        var confirm_countries = [];
        _.each(country_evidence, function (code, key) {
            if (code) {
                var keyMatch = key.match(/(.*)_code$/);
                if (keyMatch && !(code in seen)) {
                    seen[code] = true;
                    var type = keyMatch[1];
                    var name = country_evidence[type + '_name'];
                    var label = this.getCountryEvidenceLabel(type);
                    confirm_countries.push({
                        type: type,
                        label: label,
                        name: name,
                        code: code,
                    });
                }
            }
        }, this);

        var choices = $('<div class="upgradePayment__confirm-countries">');
        _.each(confirm_countries, function (country) {
            var choice = $('<div class="upgradePayment__payment upgradePayment__confirm-country">');
            var choiceButton = $('<button type="button">')
                .addClass('upgradeSchedules__button')
                .addClass('upgradeSchedules__button--action')
                .addClass('upgradePayment__button')
                .addClass('upgradePayment__button--action')
                .addClass('upgradePayment__confirm-country-button')
                .attr('data-country', country.code)
                .text(country.name);
            var choiceFlag = $('<img width="32" height="32" class="flag">').attr('src', '/static/flags/flags-iso/flat/64/' + country.code + '.png');
            var choiceLabel = $('<span>').text(' ' + country.label);
            choice.append(choiceButton).append(choiceFlag).append(choiceLabel);
            choices.append(choice);
        });

        return $('<div>')
            .append($('<p>').text("We need to confirm your country of residence to comply with European Union VAT regulations"))
            .append(choices);
    },
        
    formatStripeError: function (response) {
        var html;
        switch (response.message) {
        case 'card_error':
        case 'invalid_request':
            html = this.formatter.escapeText(response.data.message);
            break;
        case 'country_mismatch':
            html = this.formatCountryEvidence(response.country_evidence)[0].outerHTML;
            break;
        case 'request_error':
            html = 'Temporary subscription error, please wait, and contact <a href="mailto:team@irccloud.com">team@irccloud.com</a> if this problem doesn’t resolve itself.';
            break;
        default:
            html = 'Subscription failed, try again later';
        }
        return html;
    },
    showStripePayError: function (response) {
        this.$('.payStatus').hide();
        var html = this.formatStripeError(response);
        this.$('.pay').show();
        this.$('.pay .payError').html(html).fadeIn('fast');
    },
    stripeCheckoutOld: function (label, callback, options) {
        this.hidePayError();
        scriptjs.ready('stripe', _.bind(function () {
            PayViewMixins.StripeCheckout.open($.extend(true, {}, options, {
                panelLabel: label,
                closed: callback,
                token: _.bind(function (stripeResponse) {
                    debug.log('<- [STRIPE]', stripeResponse);
                    var token = stripeResponse.id;
                    if (this.seenTokens[token]) {
                        debug.warn('Seen stripe token again: ' + token);
                        debug.trace();
                        return;
                    }
                    this.seenTokens[token] = true;
                    var data = {
                        stripe_token: token,
                        stripe_token_type: stripeResponse.type
                    };
                    this.$('.pay').show();
                    this.$('.pay .payStatus').show();

                    callback(data, _.bind(function (response) {
                        this.afterPay(response);
                    }, this));
                }, this)
            }));
        }, this));
    },
    isStripeCheckoutShown: function () {
        return stripeDialog.isVisible();
    },
    stripeCheckout: function (label, callback, values) {
        this.hidePayError();
        stripeDialog.show({
            model: this.model,
            parent: this,
            label: label,
            callback: callback,
            values: values
        });
    },
    afterPay: function (response) {
        if (response.success) {
            this.$('.payStatus').hide();
            this.$('.payTrialEnds').hide();
            if (this.model.get('billing')) {
                var te = this.model.get('billing').trial_end;
                if (te) {
                    this.$('.payTrialEnds').show();
                    this.$('.payTrialEndDate').text(this.formatter.date(te));
                }
            }
            if (response.invoice) {
                this.$('.payInvoiceAmount').text(this.formatter.amount(response.invoice.currency, response.invoice.total));
            }
            this.$('.payInvoice').toggle(!!response.invoice);
            this.$('.payComplete').show();
        } else {
            this.showStripePayError(response);
        }
    },
    renderPayActiveSub: function () {

    },
    renderPayNoActiveSub: function () {
        this.$('p.payReinstate').toggle(this.model.isSubscriptionCanceled());
        this.$('p.payUpdate').toggle(this.model.isStripeSubscriptionUnpaid());

        this.$('.pay').show();
    },
    renderPayCanSeeSubscription: function () {
        this.$('.payPastDue').toggle(this.model.isStripeSubscriptionPastDue());
        if (this.model.hasActiveSubscription()) {
            this.hidePayError();
            this.renderPayActiveSub();
        } else {
            this.renderPayNoActiveSub();
        }
    },
    removeBillingInfoError: function () {
        this.$('.billingInfoError').remove();
    },
    renderBillingInfoError: function (response, failInfo) {
        this.removeBillingInfoError();
        var tpl = !failInfo.gave_up ?
            'tpl-billing-info-error-retry': 'tpl-billing-info-error';
        var billingInfoError = $($('#' + tpl).html());
        var failInfoSpan = billingInfoError.find('.failInfo');
        if (failInfo.failCount > 1) {
            failInfoSpan.text(' (' + failInfo.failCount + ' attempts)');
        }
        var close = this.$('.mainClose');
        if (close.length) {
            close.after(billingInfoError);
        } else {
            this.$el.prepend(billingInfoError);
        }
        billingInfoError.show();
    },
    renderStripeError: function () {
        var stripeError = $($('#tpl-billing-stripe-error').html());
        var close = this.$('.mainClose');
        if (close.length) {
            close.after(stripeError);
        } else {
            this.$el.prepend(stripeError);
        }
        stripeError.show();
    },
    renderPay: function () {
        this.$('.pay').hide();
        if (this.model.canSeeSubscription()) {
            this.renderPayCanSeeSubscription();
        }
    },
    getSubscriptionStatus: function () {
        var subStatus = $($('#tpl-billing-sub-status').html());
        return $('<div>').append(subStatus).html();
    },
    getNewPayButtons: function () {
        var tpl;
        if (!this.model.hasActiveSubscription()) {
            tpl = 'billing-pay-new';
        }
        if (tpl) {
            var payButtons = $($('#tpl-' + tpl).html());
            return $('<div>').append(payButtons).html();
        }
    },
    formatStripeSubscriptionBilling: function (sub) {
        var billing = $('<span>');
        if (sub.type) {
            if (sub.country) {
                billing.append($('<img height="16" width="16">').attr({
                    'src': '/static/flags/flags-iso/flat/32/' + sub.country + '.png',
                    'alt': sub.country,
                    'title': sub.country
                }));
                billing.append(' ');
            }
            if (sub.name) {
                billing.append($('<span>').text(sub.name));
                billing.append(' ');
            }
            if (sub.last4) {
                billing.append($('<span>').text('•••• •••• •••• •••• ' + sub.last4));
                billing.append(' ');
            }
            if (sub.exp_month || sub.exp_year) {
                billing.append('Expires: ');
            }
            if (sub.exp_month) {
                billing.append($('<span>').text(sub.exp_month));
                billing.append(' ');
                if (sub.exp_year) {
                    billing.append('/ ');
                }
            }
            if (sub.exp_year) {
                billing.append($('<span>').text(sub.exp_year));
                billing.append(' ');
            }
            // address_city
            // address_country
            // address_line1
            // address_line1_check
            // address_line2
            // address_state
            // address_zip
            // address_zip_check
        } else if (sub.source && sub.source.object == 'bitcoin_receiver') {
            var btcAmount = this.formatter.amount('BTC', sub.source.bitcoin_amount_received);
            billing.append(btcAmount);
            billing.append(' ');
            billing.append(this.formatter.escapeText(sub.source.inbound_address));
            billing.append(' ');
        }
        return billing;
    },
    formatStripeSubscriptionTypeImg: function (sub) {
        var img = $('<img height="16">');
        if (sub.type) {
            img.attr({
                'src': '/static/cards/' + util.slugify(sub.type) + '-curved-32px.png',
                'title': sub.type,
                'alt': sub.type
            });
        } else if (sub.source && sub.source.object == 'bitcoin_receiver') {
            img.attr({
                'src': '/static/btc-icon.png',
                'title': 'Bitcoin',
                'alt': 'Bitcoin'
            });
        }
        return img;
    },
    renderStripeUpdateButton: function (customerId) {
        var updateButton = $('<button type="button">').append($('<span>').text('Update'));
        updateButton.on('buttonClick', _.bind(function (e) {
            e.preventDefault();
            this.stripeCheckout(
                'Update card details',
                _.bind(function (data, callback) {
                    if (data) {
                        data.customer_id = customerId;
                        this.model.updateCustomer(data, callback);
                    }
                }, this),
                {
                    description: 'Update card details'
                }
            );
        }, this));
        return updateButton;
    },
    renderStripeRestoreButton: function (customerId) {
        var restoreButton = $('<button class="action">').append($('<span>').text('Restore'));
        restoreButton.on('buttonClick', _.bind(function (e) {
            e.preventDefault();
            this.hidePayError();
            this.$('.pay .payStatus').show();
            this.model.reinstateSubscription({
                customer_id: customerId
            }, _.bind(function (response) {
                this.afterPay(response);
            }, this));
        }, this));
        return restoreButton;
    },
    renderCancelForm: function (condition, className, action, data) {
        if (condition) {
            var cancelForm = $($('#tpl-billing-cancel-confirm').html());
            var form = cancelForm.find('form.billingCancelForm');
            var buttons = form.find('.billingCancelButtons');
            var status = form.find('.billingCancelStatus');
            var error = form.find('.billingCancelError');
            form.addClass(className);
            form.submit(function (e) {
                e.preventDefault();
                status.show();
                buttons.hide();
                action(data, function (response) {
                    if (!response.success) {
                        status.hide();
                        buttons.show();
                        error.text('There was a problem canceling your subscription: ' + response.message).fadeIn('fast');
                    }
                });
            });
            buttons.find('.cancel').click(function (e) {
                e.preventDefault();
                error.hide();
                cancelForm.hide();
            });
            var cancelButton = $('<button class="delete">').append($('<span>').text('Cancel')).on('buttonClick', function (e) {
                e.preventDefault();
                cancelForm.fadeIn('fast');
            });
            return [cancelForm, cancelButton];
        }
    },
    formatStripeSubscriptionItem: function (sub, ii) {
        var row = $('<tr class="subscription">');
        if (
            !sub.active ||
            _.include(['unpaid', 'canceled', 'incomplete', 'incomplete_expired'], sub.subscription) ||
            (sub.subscription == 'trialing' && sub.cancel_at_period_end)
        ) {
            row.addClass('inactive');
        }

        // 1 date
        row.append($('<td class="dateCell">').text(this.formatter.date(sub.created)));

        // 2 description
        var description = this.formatPlan(sub);
        row.append($('<td class="descriptionCell">').append(description));

        // 3 status
        var status = '';
        switch (sub.subscription) {
        case 'trialing':
            if (sub.cancel_at_period_end) {
                status += 'Cancelled';
            } else if (!sub.ended_at) {
                status += 'Active — starting on ' + this.formatter.date(sub.trial_end);
            }
            break;
        case 'past_due':
            status += 'Active - last payment failed (check your card details)';
            break;
        case 'unpaid':
            status += 'Disabled (check your card details)';
            break;
        case 'incomplete':
            status += 'Incomplete (update card details)';
            break;
        case 'canceled':
        case 'incomplete_expired':
            status += 'Expired on ' + this.formatter.date(sub.ended_at) + ' (cancelled on ' + this.formatter.date(sub.canceled_at) + ')';
            break;
        case 'active':
            if (sub.cancel_at_period_end) {
                status += 'Cancelled — expiring on ' + this.formatter.date(sub.current_period_end);
            } else if (!sub.ended_at) {
                status += 'Active — next invoice on ' + this.formatter.date(sub.current_period_end);
            }
            break;
        }
        var statusCell = $('<td class="statusCell">').append(status + ' ');
        row.append(statusCell);

        // 4 type
        var img = $('<td class="typeCell">');
        img.append(this.formatStripeSubscriptionTypeImg(sub));
        row.append(img);
        
        // 5 extra
        var extra = $('<td class="detailCell">');
        extra.append(this.formatStripeSubscriptionBilling(sub));
        var active = sub.active && _.include(
            ['active', 'trialing', 'past_due'],
            sub.subscription
        );
        if (active && sub.cancel_at_period_end) {
            extra.append(this.renderStripeRestoreButton(sub.customer_id));
            extra.append(' ');
        }
        if (!sub.ended_at && !sub.cancel_at_period_end) {
            extra.append(this.renderStripeUpdateButton(sub.customer_id));
            extra.append(' ');
        }
        row.append(extra);
        
        var cancelFormParts = this.renderCancelForm(
            (!sub.ended_at && !sub.cancel_at_period_end),
            'billingCancelStripeForm',
            _.bind(this.model.cancelStripeSubscription, this.model),
            {customer_id: sub.customer_id}
        );
        
        var billingExtras;
        if (!sub.ended_at && !sub.cancel_at_period_end && ((ii && ii.length) || sub.account_balance)) {
            billingExtras = $('<div class="invoiceItemsWrap">');
            statusCell.append($('<a href="">').text('details').click(function (e) {
                e.preventDefault();
                billingExtras.slideToggle('fast');
            }));
            
            var invoiceItems = $('<table class="invoiceItems">');
            var total = 0;

            var planAmount = sub.amount * sub.quantity;
            total += planAmount;
            var planRow = $('<tr>');
            planRow.append('<td>Subscription</td>');
            planRow.append($('<td>'));
            planRow.append($('<td class="amountCell">').text(this.formatter.amount(sub.currency, planAmount)));
            invoiceItems.append(planRow);

            _.each(ii, function (item) {
                total += item.amount;
                var itemRow = $('<tr>');
                itemRow.append($('<td>').text(item.description));
                itemRow.append($('<td>').text(this.formatter.amountSign(item.amount)));
                itemRow.append($('<td class="amountCell">').text(this.formatter.amount(item.currency, Math.abs(item.amount))));
                itemRow.append($('<td>').text(this.formatter.date(item.date)));
                invoiceItems.append(itemRow);
            }, this);
            if (sub.account_balance) {
                total += sub.account_balance;
                var balRow = $('<tr>');
                var bal = sub.account_balance;
                var rem = '';
                if (sub.account_balance < 0) {
                    if (total < 0) {
                        rem = total * -1;
                        bal = bal - total;
                        total = 0;
                    }
                    bal = bal * -1;
                    balRow.append('<td>Credit</td>');
                    balRow.append($('<td>'));
                } else {
                    balRow.append('<td>Unpaid charges</td>');
                    balRow.append($('<td>').text('-'));
                }
                if (rem) {
                    rem = ' (' + this.formatter.amount(sub.currency, rem) + ' remains)';
                }
                balRow.append($('<td class="amountCell">').text(this.formatter.amount(sub.currency, bal) + rem));
                invoiceItems.append(balRow);
            }
            var totalRow = $('<tr>');
            totalRow.append('<th class="total">Total</th>');
            totalRow.append($('<td>').text(this.formatter.amountSign(total)));
            totalRow.append($('<td class="amountCell">').text(this.formatter.amount(sub.currency, Math.abs(total))));
            invoiceItems.append(totalRow);
            billingExtras.append(invoiceItems);
        }
        if (cancelFormParts || billingExtras) {
            var secondRow = $('<tr>');
            var secondRowCell = $('<td colspan="5" class="extraRow">');
            if (cancelFormParts) {
                extra.append(cancelFormParts[1]);
                extra.append(' ');
                secondRowCell.append(cancelFormParts[0]);
            }
            if (billingExtras) {
                secondRowCell.append(billingExtras);
            }
            secondRow.append(secondRowCell);
            return [row, secondRow];
        } else {
            return row;
        }
    },
    formatPayPalSubscriptionItem: function (sub) {
        var row = $('<tr class="subscription">');
        if (sub.subscription == 'expired') {
            row.addClass('inactive');
        }

        // 1 date
        row.append($('<td class="dateCell">').text(this.formatter.date(sub.startdate)));

        // 2 description
        var description = this.formatPlan(sub);
        row.append($('<td class="descriptionCell">').append(description));

        // 3 status
        var status = '';
        switch (sub.subscription) {
        case 'expired':
            status += 'Expired on ' + this.formatter.date(sub.enddate);
            if (sub.cancelled_at) {
                status += ' (cancelled on ' + this.formatter.date(sub.cancelled_at) + ')';
            }
            break;
        case 'cancelled':
            status += 'Cancelled — expiring ';
            if (sub.expiring) {
                status += 'on ' + this.formatter.date(sub.expiring);
            } else {
                status += 'at the end of the cycle';
            }
            break;
        case 'active':
            status += 'Active';
            if (sub.next_billing_date) {
                status += ' — next invoice on ' + this.formatter.date(sub.next_billing_date);
            }
            break;
        }
        row.append($('<td class="statusCell">').append(status));

        // 4 type
        row.append($('<td class="typeCell">').append('<img src="/static/cards/paypal-curved-32px.png" height="16" title="PayPal" alt="PayPal">'));

        // 5 extra
        var extra = $('<td class="detailCell">');
        row.append(extra);
        
        var cancelFormParts = this.renderCancelForm(
            (sub.subscription == 'active'),
            'billingCancelPaypalForm',
            _.bind(this.model.cancelPaypalSubscription, this.model),
            {subscr_id: sub.subscr_id}
        );
        if (cancelFormParts) {
            var secondRow = $('<tr>');
            var secondRowCell = $('<td colspan="5" class="extraRow">');
            
            extra.append(cancelFormParts[1]);
            extra.append(' ');
            secondRowCell.append(cancelFormParts[0]);
            
            secondRow.append(secondRowCell);
            return [row, secondRow];
        } else {
            return row;
        }
    },
    formatAndroidSubscriptionItem: function (sub) {
        var row = $('<tr class="subscription">');
        if (sub.subscription != 'active' && sub.subscription != 'grace_period') {
            row.addClass('inactive');
        }

        // 1 date
        row.append($('<td class="dateCell">').text(this.formatter.date(sub.start_date)));

        // 2 description
        var description = this.formatPlan(sub);
        row.append($('<td class="descriptionCell">').append(description));

        // 3 status
        var status = '';
        switch (sub.subscription) {
        case 'cancelled':
            status += 'Cancelled';
            if (sub.cancelled_at) {
                status += ' on ' + this.formatter.date(sub.cancelled_at);
            }
            break;
        case 'grace_period':
            status += 'Grace period';
            if (sub.next_payment_date) {
                status += ' — next charge on ' + this.formatter.date(sub.next_payment_date);
            }
            break;
        case 'on_hold':
            status += 'On Hold';
            break;
        case 'paused':
            status += 'Paused';
            if (sub.resuming_at) {
                status += ' — resuming on ' + this.formatter.date(sub.resuming_at);
            }
            break;
        case 'active':
            if (sub.cancelled) {
                status += 'Cancelled — expiring on ' + this.formatter.date(sub.end_date);
            } else {
                status += 'Active';
                if (sub.next_payment_date) {
                    status += ' — next charge on ' + this.formatter.date(sub.next_payment_date);
                }
            }
            break;
        }
        row.append($('<td class="statusCell">').append(status));

        // 4 type
        row.append($('<td class="typeCell">').append('<img src="/static/cards/google-play-32px.png" height="16" title="Google Play" alt="Google Play">'));

        // 5 extra
        var extra = $('<td class="detailCell">');
        extra.append('<a href="https://play.google.com/store/account/orderhistory" target="_blank">Order history</a>');
        if (sub.active) {
            extra.append(' • <a href="https://play.google.com/store/account/subscriptions?sku=' + sub.plan + '&package=' + sub.package + '" target="_blank">Manage</a>');
        }
        if (sub.last_order_id) {
            extra.append(' — ');
            extra.append($('<span>').text(sub.last_order_id));
        }
        row.append(extra);
        
        return row;
    },
    formatOneOffSubscriptionItem: function (sub, charge) {
        var row = $('<tr class="subscription">');
        if (!sub.active) {
            row.addClass('inactive');
        }

        // 1 date
        row.append($('<td class="dateCell">').text(this.formatter.date(sub.start_date)));

        // 2 description
        var description = this.formatOneOffPlan(sub, charge);
        row.append($('<td class="descriptionCell">').append(description));

        // 3 status
        var status = '';
        if (sub.active) {
            status += 'Active — expiring on';
        } else {
            status += 'Expired on';
        }
        status += ' ' + this.formatter.date(sub.end_date);
        row.append($('<td class="statusCell">').append(status));

        // 4 type
        // 5 extra
        var extra = $('<td class="detailCell">');
        var img = $('<td class="typeCell">');
        if (sub.paypal_txn_id) {
            img.append('<img src="/static/cards/paypal-curved-32px.png" height="16" title="PayPal" alt="PayPal">');
        } else if (sub.android_id) {
            img.append('<img src="/static/cards/google-play-32px.png" height="16" title="Google Play" alt="Google Play">');
        } else if (charge) {
            extra.append(this.formatStripeSubscriptionBilling(charge));
            img.append(this.formatStripeSubscriptionTypeImg(charge));
        }
        
        row.append(img);
        row.append(extra);
        if (sub.android_id) {
            extra.append('<a href="https://play.google.com/store/account/orderhistory" target="_blank">Order history</a>');
            if (charge) {
                extra.append(' — ');
                extra.append($('<span>').text(charge.order_id));
            }
        }

        return row;
    },
    formatStripeChargeDescription: function (charge) {
        var description;
        if (charge.metadata && charge.metadata.oneoff && charge.metadata.interval && charge.metadata.interval_count) {
            var endDate = new Date(charge.created*1000);
            var addConfig = {};
            addConfig[charge.metadata.interval + 's'] = charge.metadata.interval_count;
            endDate.add(addConfig);
            description = 'One off subscription for ' + this.formatter.date(charge.created) + ' — ' + this.formatter.date(endDate.getTime()/1000);
        } else {
            description = this.formatter.escapeText(charge.description);
        }
        if (!charge.paid) {
            description += ' — <span class="failed"><strong>Failed:</strong> ' + this.formatter.escapeText(charge.failure_message) + '</span>';
        }
        return description;
    },
    formatStripeInvoice: function (invoice, charge) {
        var row = $('<tr class="charge">');

        // 1 date
        row.append($('<td class="dateCell">').append('<a href="' + this.model.getInvoiceUrl(invoice.id) + '" target="_blank">' + this.formatter.date(invoice.date) + '</a>'));

        // 2 type
        var img = $('<td class="typeCell">');
        if (charge && charge.type) {
            img.append($('<img height="16">').attr({
                'src': '/static/cards/' + util.slugify(charge.type) + '-curved-32px.png',
                'title': charge.type,
                'alt': charge.type
            }));
        }
        row.append(img);

        // 3 amount
        var amount = this.formatter.amount(invoice.currency, invoice.total);
        if (invoice.starting_balance) {
            amount += ' ( ';
            if (invoice.starting_balance > 0) {
                amount += '+ ' + this.formatter.amount(invoice.currency, invoice.starting_balance) + ' unpaid charges';
            } else {
                amount += '− ' + this.formatter.amount(invoice.currency, invoice.starting_balance * -1) + ' credit';
            }
            amount += ' )';
        }
        row.append($('<td class="amountCell">').append(amount));

        // 4 description
        var description = '';
        var sub = _.find(invoice.lines.data, function (line) {
            return line.type == 'subscription';
        });
        if (sub) {
            description += this.formatSubscriptionInvoiceItem(sub);
        } else if (invoice.lines.data.length === 1) {
            description += this.formatter.escapeText(invoice.lines.data[0].description);
        } else if (invoice.lines.data.length > 1) {
            description += invoice.lines.data.length + ' line items';
        }
        if (!invoice.paid) {
            description += ' — ';
            if (invoice.closed) {
                description += 'Closed';
            } else if (invoice.attempted) {
                if (charge && charge.failure_code == 'authentication_required') {
                    description += '<span class="failed">Authentication needed</span> ';
                    description += '<button type="button"><a href="' + this.model.getHostedInvoiceUrl(invoice.id) + '" target="_blank">';
                    description += 'Confirm payment';
                    description += '</a></button> ';
                } else {
                    description += '<span class="failed"><strong>Failed:</strong> ';
                    if (charge) {
                        description += this.formatter.escapeText(charge.failure_message) + ' — ';
                    }
                    if (invoice.next_payment_attempt > 0) {
                        description += 'Retrying on ' + this.formatter.date(invoice.next_payment_attempt);
                    } else {
                        description += 'Gave up retrying';
                    }
                    description += '</span>';
                }
            } else {
                if (invoice.amount_due) {
                    if (invoice.next_payment_attempt > 0) {
                        description += 'Due on ' + this.formatter.date(invoice.next_payment_attempt);
                    } else {
                        description += 'Pending';
                    }
                } else {
                    description += 'No charge';
                }
            }
        }
        row.append($('<td class="descriptionCell">').append(description));

        // 5 status
        var status = $('<td class="statusCell">');
        if (invoice.paid) {
            status.addClass('paid');
            status.append('paid');
        } else if (invoice.closed) {
            status.append('closed');
        } else if (invoice.attempted) {
            status.append('<span style="color: red;">unpaid</span>');
        } else {
            status.append('unattempted');
        }
        
        var refund = '';
        if (charge && charge.amount_refunded) {
            if (charge.refunded) {
                refund += 'fully';
            } else {
                refund += this.formatter.amount(charge.currency, charge.amount_refunded);
            }
            refund += ' refunded';
        }
        if (refund) {
            status.append(' — ' + refund);
        }
        row.append(status);

        return row;
    },
    formatStripeCharge: function (charge) {
        var row = $('<tr class="charge">');

        // 1 date
        row.append($('<td class="dateCell">').append('<a href="' + this.model.getReceiptUrl(charge.id) + '" target="_blank">' + this.formatter.date(charge.created) + '</a>'));

        // 2 type
        var img = $('<td class="typeCell">');
        if (charge.type) {
            img.append($('<img height="16">').attr({
                'src': '/static/cards/' + util.slugify(charge.type) + '-curved-32px.png',
                'title': charge.type,
                'alt': charge.type
            }));
        } else if (charge.source && charge.source.object == 'bitcoin_receiver') {
            img.append('<img src="/static/btc-icon.png" height="16" title="Bitcoin" alt="Bitcoin">');
        }
        row.append(img);

        // 3 amount
        var amount = '';
        if (charge.source && charge.source.object == 'bitcoin_receiver') {
            var btcAmount = this.formatter.amount('BTC', charge.source.bitcoin_amount_received);
            amount += btcAmount + ' / ';
        }
        amount += this.formatter.amount(charge.currency, charge.amount);
        row.append($('<td class="amountCell">').append(amount));

        // 4 description
        var description = this.formatStripeChargeDescription(charge);
        row.append($('<td class="descriptionCell">').append(description));

        // 5 status
        var status = $('<td class="statusCell paid">').append('paid');
        var refund = '';
        if (charge.amount_refunded) {
            if (charge.refunded) {
                refund += 'fully';
            } else {
                refund += this.formatter.amount(charge.currency, charge.amount_refunded);
            }
            refund += ' refunded';
        }
        if (refund) {
            status.append(' — ' + refund);
        }
        row.append(status);
        
        return row;
    },
    formatPayPalCharge: function (charge, refunds) {
        var row = $('<tr class="charge">');

        // 1 date
        row.append($('<td class="dateCell">').append('<a href="' + this.model.getPayPalReceiptUrl(charge.id) + '" target="_blank">' + this.formatter.date(charge.created) + '</a>'));

        // 2 type
        row.append($('<td class="typeCell">').append('<img src="/static/cards/paypal-curved-32px.png" height="16" title="PayPal" alt="PayPal">'));

        // 3 amount
        var amount = this.formatter.amount(charge.currency, charge.amount);
        row.append($('<td class="amountCell">').append(amount));

        // 4 description
        var description = this.formatSubscriptionInvoiceItem(charge);
        row.append($('<td class="descriptionCell">').append(description));

        // 5 status
        var status = $('<td class="statusCell paid">').append('paid');
        var refund = '';
        if (refunds) {
            var amountRefunded = _.reduce(refunds, function (acc, r) {
                return acc + r.amount;
            }, 0);
            if ((charge.amount + amountRefunded) === 0) {
                refund += 'fully';
            } else {
                refund += this.formatter.amount(charge.currency, -amountRefunded);
            }
            refund += ' refunded';
        }
        if (refund) {
            status.append(' — ' + refund);
        }
        row.append(status);

        return row;
    },
    formatPayPalOneOffCharge: function (charge, refunds) {
        var row = $('<tr class="charge">');

        // 1 date
        row.append($('<td class="dateCell">').append('<a href="' + this.model.getPayPalReceiptUrl(charge.id) + '" target="_blank">' + this.formatter.date(charge.start_date) + '</a>'));

        // 2 type
        row.append($('<td class="typeCell">').append('<img src="/static/cards/paypal-curved-32px.png" height="16" title="PayPal" alt="PayPal">'));

        // 3 amount
        var amount = this.formatter.amount(charge.currency, charge.amount);
        row.append($('<td class="amountCell">').append(amount));

        // 4 description
        var description = this.formatOneOffSubscriptionInvoiceItem(charge);
        row.append($('<td class="descriptionCell">').append(description));

        // 5 status
        var status = $('<td class="statusCell paid">').append('paid');
        var refund = '';
        if (refunds) {
            var amountRefunded = _.reduce(refunds, function (acc, r) {
                return acc + r.amount;
            }, 0);
            if ((charge.amount + amountRefunded) === 0) {
                refund += 'fully';
            } else {
                refund += this.formatter.amount(charge.currency, -amountRefunded);
            }
            refund += ' refunded';
        }
        if (refund) {
            status.append(' — ' + refund);
        }
        row.append(status);

        return row;
    },
    formatAndroidCharge: function (charge) {
        var row = $('<tr class="charge">');

        // 1 date
        row.append(
            $('<td class="dateCell">')
                .append('<a href="https://play.google.com/store/account/orderhistory" target="_blank">' + this.formatter.date(charge.created) + '</a>')
                .append(' — ')
                .append($('<span>').text(charge.order_id))
        );

        // 2 type
        row.append($('<td class="typeCell">').append('<img src="/static/cards/google-play-32px.png" height="16" title="PayPal" alt="PayPal">'));

        // 3 amount
        var amount = this.formatter.amount(charge.currency, charge.amount);
        row.append($('<td class="amountCell">').append(amount));

        // 4 description
        var description = this.formatSubscriptionInvoiceItem(charge);
        row.append($('<td class="descriptionCell">').append(description));

        // 5 status
        var status = $('<td class="statusCell">');
        if (charge.paid) {
            status.addClass('paid');
            status.append('paid');
        } else {
            status.append('unpaid or refunded');
        }
        row.append(status);

        return row;
    },
    formatAndroidOneOffCharge: function (charge) {
        var row = $('<tr class="charge">');

        // 1 date
        row.append(
            $('<td class="dateCell">')
                .append('<a href="https://play.google.com/store/account/orderhistory" target="_blank">' + this.formatter.date(charge.start_date) + '</a>')
                .append(' — ')
                .append($('<span>').text(charge.order_id))
        );

        // 2 type
        row.append($('<td class="typeCell">').append('<img src="/static/cards/google-play-32px.png" height="16" title="Google Play" alt="Google Play">'));

        // 3 amount
        var amount = this.formatter.amount(charge.currency, charge.amount);
        row.append($('<td class="amountCell">').append(amount));

        // 4 description
        var description = this.formatOneOffSubscriptionInvoiceItem(charge);
        row.append($('<td class="descriptionCell">').append(description));

        // 5 status
        var status = $('<td class="statusCell">');
        if (charge.paid) {
            status.addClass('paid');
            status.append('paid');
        } else {
            status.append('unpaid or refunded');
        }
        row.append(status);

        return row;
    },

    getOneOffCharge: function (oo, oneOffChargeLookup) {
        return oneOffChargeLookup.paypal[oo.paypal_txn_id] || oneOffChargeLookup.stripe[oo.stripe_charge_id] || oneOffChargeLookup.android[oo.android_id];
    },
    formatBillingDetails: function () {
        var contents = $('<div>');

        var c = this.model.get('charges');
        var inv = this.model.get('invoices');
        var ii = this.model.get('invoice_items');
        var ppc = this.model.get('paypal_charges');
        var ppoc = this.model.get('paypal_oneoff_charges');
        var ac = this.model.get('android_charges');
        var aoc = this.model.get('android_oneoff_charges');
        
        var subs = this.model.get('subscriptions');
        
        if (subs || inv || c || ppc) {
            var formats = [];
            
            formats.push({
                footer: this.getSubscriptionStatus()
            });
            
            // Subscriptions
            
            var subscriptions = [];
            var allSubscriptions = [];
            var subscriptionLookup = {};
            if (subs) {
                _.each(subs.stripe, function (sub) {
                    subscriptionLookup[sub.customer_id] = sub;
                    allSubscriptions.push({
                        type: 'stripe',
                        start: sub.created,
                        data: sub
                    });
                });
                _.each(subs.paypal, function (sub) {
                    allSubscriptions.push({
                        type: 'paypal',
                        start: sub.startdate,
                        data: sub
                    });
                });
                _.each(subs.android, function (sub) {
                    allSubscriptions.push({
                        type: 'android',
                        start: sub.start_date,
                        data: sub
                    });
                });
                _.each(subs.oneoff, function (sub) {
                    allSubscriptions.push({
                        type: 'oneoff',
                        start: sub.start_date,
                        data: sub
                    });
                });
            }
            
            // Charges

            var charges = [];
            var allCharges = [];
            var payPalRefunds = {};
            var invoiceCharges = {};
            var oneOffChargeLookup = {
                paypal: {},
                stripe: {},
                android: {}
            };
            if (inv) {
                _.each(inv, function (invoice) {
                    // Filter out initial and pending invoices for past due subscriptions
                    // as well as incomplete subscriptions
                    var invSub = subscriptionLookup[invoice.customer_id];
                    if (
                        invoice.total > 0 &&
                        (
                            invoice.paid ||
                            invoice.attempted ||
                            !invoice.amount_due ||
                            invoice.next_payment_attempt > 0
                        )
                    ) {
                        allCharges.push({
                            type: 'stripe_invoice',
                            date: invoice.date,
                            data: invoice
                        });
                    }
                });
            }
            if (c) {
                _.each(c, function (charge) {
                    if (charge.metadata && charge.metadata.oneoff) {
                        oneOffChargeLookup.stripe[charge.id] = charge;
                    }
                    if (charge.invoice) {
                        invoiceCharges[charge.invoice] = charge;
                    } else {
                        allCharges.push({
                            type: 'stripe_charge',
                            date: charge.created,
                            data: charge
                        });
                    }
                });
            }
            if (ppc) {
                _.each(ppc, function (charge) {
                    if (charge.refund) {
                        if (!payPalRefunds[charge.refund]) {
                            payPalRefunds[charge.refund] = [];
                        }
                        payPalRefunds[charge.refund].push(charge);
                    } else {
                        allCharges.push({
                            type: 'paypal_charge',
                            date: charge.created,
                            data: charge
                        });
                    }
                });
            }
            if (ppoc) {
                _.each(ppoc, function (charge) {
                    oneOffChargeLookup.paypal[charge.id] = charge;
                    if (charge.refund) {
                        if (!payPalRefunds[charge.refund]) {
                            payPalRefunds[charge.refund] = [];
                        }
                        payPalRefunds[charge.refund].push(charge);
                    } else {
                        allCharges.push({
                            type: 'paypal_oneoff_charge',
                            date: charge.created,
                            data: charge
                        });
                    }
                });
            }
            if (ac) {
                _.each(ac, function (charge) {
                    allCharges.push({
                        type: 'android_charge',
                        date: charge.created,
                        data: charge
                    });
                });
            }
            if (aoc) {
                _.each(aoc, function (charge) {
                    oneOffChargeLookup.android[charge.id] = charge;
                    allCharges.push({
                        type: 'android_oneoff_charge',
                        date: charge.created,
                        data: charge
                    });
                });
            }
            if (allCharges.length) {
                allCharges = _.sortBy(allCharges, 'date').reverse();
                charges.push({
                    name: 'Payment history',
                    items: [{
                        format: _.bind(function () {
                            var table = $('<table class="charges">');
                            var headRow = $('<tr class="head">');
                            headRow.append('<th class="dateCell">Date</th>');
                            headRow.append('<th class="amountCell" colspan="2">Payment</th>');
                            headRow.append('<th class="descriptionCell">Description</th>');
                            headRow.append('<th class="statusCell">Status</th>');
                            table.append(headRow);
                            _.each(allCharges, function (charge) {
                                var row;
                                switch (charge.type) {
                                case 'stripe_invoice':
                                    row = this.formatStripeInvoice(charge.data, invoiceCharges[charge.data.id]);
                                    break;
                                case 'stripe_charge':
                                    row = this.formatStripeCharge(charge.data);
                                    break;
                                case 'paypal_charge':
                                    row = this.formatPayPalCharge(charge.data, payPalRefunds[charge.data.id]);
                                    break;
                                case 'paypal_oneoff_charge':
                                    row = this.formatPayPalOneOffCharge(charge.data, payPalRefunds[charge.data.id]);
                                    break;
                                case 'android_charge':
                                    row = this.formatAndroidCharge(charge.data);
                                    break;
                                case 'android_oneoff_charge':
                                    row = this.formatAndroidOneOffCharge(charge.data);
                                    break;
                                }
                                table.append(row);
                            }, this);
                            return table;
                        }, this)
                    }]
                });
            }
            
            if (allSubscriptions.length) {
                allSubscriptions = _.sortBy(allSubscriptions, 'start').reverse();
                subscriptions.push({
                    name: 'Subscriptions',
                    items: [{
                        format: _.bind(function () {
                            var table = $('<table class="subscriptions">');
                            var headRow = $('<tr class="head">');
                            headRow.append('<th class="dateCell">Started</th>');
                            headRow.append('<th class="descriptionCell">Description</th>');
                            headRow.append('<th class="statusCell" colspan="2">Status</th>');
                            headRow.append('<th class="detailCell">Details</th>');
                            table.append(headRow);
                            _.each(allSubscriptions, function (sub) {
                                var row;
                                switch (sub.type) {
                                case 'stripe':
                                    var subII = _.filter(ii, function (iii) {
                                        return iii.customer_id == sub.data.customer_id;
                                    });
                                    row = this.formatStripeSubscriptionItem(sub.data, subII);
                                    break;
                                case 'paypal':
                                    row = this.formatPayPalSubscriptionItem(sub.data);
                                    break;
                                case 'android':
                                    row = this.formatAndroidSubscriptionItem(sub.data);
                                    break;
                                case 'oneoff':
                                    row = this.formatOneOffSubscriptionItem(sub.data, this.getOneOffCharge(sub.data, oneOffChargeLookup));
                                    break;
                                }
                                table.append(row);
                            }, this);
                            return table;
                        }, this)
                    }]
                });
                var footerButtons = this.getNewPayButtons();
                if (footerButtons) {
                    subscriptions.push({
                        footer: footerButtons
                    });
                }
            }
            
            // Do the render
            var mergedFormats = formats.concat(subscriptions, charges);
            
            _.each(mergedFormats, function (section) {
                var anyItems;
                var container = $('<div class="billing">');
                _.each(section.items, function (item) {
                    var value;
                    if ('format' in item) {
                        value = item.format();
                    }
                    if (value === null) {
                        value = '-';
                    }
                    if (value) {
                        anyItems = true;
                        container.append(value);
                    }
                });
                if (anyItems || section.footer) {
                    var sectionContents = $('<div>').addClass(section.className);
                    if (anyItems) {
                        sectionContents.append($('<h2 tabindex="0">').html(section.name));
                        if (section.header) {
                            sectionContents.append($('<div>').html(section.header));
                        }
                        sectionContents.append(container);
                    }
                    if (section.footer) {
                        sectionContents.append($('<div>').html(section.footer));
                    }
                    contents.append(sectionContents);
                }
            }, this); // each mergedFormats
        } else { // if b || c || ppb || ppc
            contents.append(this.getSubscriptionStatus());
        }
        contents.find('.billingCancelSure').html(this.billingCancelSureText);
        return contents;
    }
};

module.exports = PayViewMixins;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/mixins/payviewmixins.js
// module id = eIfS
// module chunks = 1